module.exports = __webpack_public_path__ + "img/anuncio1.e8715ffb.jpg";